import { LearnerNavRouteStaticDataType } from './types';
import { NAVIGATION_LEARNER_MENU_LIST } from './enums';
import { DefaultTabEnabledMap } from './constants';

export const getLearnerIsTabEnabledMap = (navConfig: LearnerNavRouteStaticDataType[]) => {
  let tabMap = { ...DefaultTabEnabledMap };

  if (navConfig && navConfig.length > 0) {
    const navIdMap: Record<string, boolean> = {};
    navConfig.forEach(item => {
      navIdMap[item.id] = true;
    });

    tabMap = {
      homeEnabled: !!navIdMap[NAVIGATION_LEARNER_MENU_LIST.HOME],
      trainingEnabled: !!navIdMap[NAVIGATION_LEARNER_MENU_LIST.TRAINING],
      assetsEnabled: !!navIdMap[NAVIGATION_LEARNER_MENU_LIST.ASSETS],
      dsrEnabled: !!navIdMap[NAVIGATION_LEARNER_MENU_LIST.DSR],
      callAIEnabled: !!navIdMap[NAVIGATION_LEARNER_MENU_LIST.CALL_AI],
      coachingEnabled: !!navIdMap[NAVIGATION_LEARNER_MENU_LIST.COACHING],
      sellerIntelEnabled: !!navIdMap[NAVIGATION_LEARNER_MENU_LIST.SELLER_INTEL],
      revenueIntelEnabled: !!navIdMap[NAVIGATION_LEARNER_MENU_LIST.REVENUE_INTELLIGENCE],
      teamAnalyticsEnabled: !!navIdMap[NAVIGATION_LEARNER_MENU_LIST.TEAM_ANALYTICS],
      assistantEnabled: !!navIdMap[NAVIGATION_LEARNER_MENU_LIST.ASSISTANT],
    };
  }

  return tabMap;
};
